// extracted by mini-css-extract-plugin
export default {"MainPage":"MainPage_MainPage__fPmzA"};